import { ShieldCheck } from 'lucide-react';

/**
 * Avertissement sur les questions générées par IA (thématiques perso).
 * Décrit exactement la chaîne réelle : génération, puis relecture automatique par un second modèle
 * (QcmReviewer) qui ÉCARTE les questions douteuses sans les corriger ; aucune validation humaine.
 * Ne pas écrire « double vérification » : cela laisserait croire à une relecture humaine.
 * Variantes : 'full' (avant génération : carte d'essai, page de création), 'line' (page de la thématique).
 */
export default function AiContentNotice({ variant = 'full' }) {
    if (variant === 'line') {
        return (
            <p className="ai-notice ai-notice--line">
                <ShieldCheck size={14} />
                <span>Questions générées par IA puis relues par une seconde IA. Des erreurs ou approximations peuvent subsister : en cas de doute, vérifiez dans votre cours.</span>
            </p>
        );
    }
    return (
        <div className="ai-notice">
            <ShieldCheck size={16} />
            <p>
                <strong>Questions générées par IA.</strong> Chaque lot est relu automatiquement par une seconde IA, plus exigeante,
                qui écarte les questions douteuses. Des erreurs ou approximations peuvent subsister : en cas de doute, vérifiez
                dans votre cours. Les thématiques éditoriales de MonQuiz suivent, elles, une triple relecture IA et une validation humaine.
            </p>
        </div>
    );
}
